module.exports = __webpack_public_path__ + "img/act-of-emotion-1-mobile.374bbec2.jpg";